/*
 * Wildcard de busca: adiciona "*" ao termo no momento do submit (melhora a
 * indexação no Shopify), mas NUNCA deixa o "*" visível para o cliente.
 *
 * Por que JS e não CSS: o texto dentro de um <input> é renderizado como bloco
 * único — não há seletor CSS capaz de mirar apenas o último caractere. A única
 * forma robusta de "ocultar o *" é não exibi-lo: enviamos com "*" e, na página
 * de resultados, limpamos o "*" do que o Shopify devolve em search.terms
 * (inputs com value e o título <h1>).
 */
(function () {
  // Remove um único "*" no fim de uma string (com ou sem espaços sobrando).
  function stripTrailingWildcard(value) {
    return value.replace(/\s*\*\s*$/, '');
  }

  function init() {
    // 1) No submit: garante o "*" no fim do termo enviado ao Shopify.
    document.querySelectorAll('.search-modal__form').forEach(function (form) {
      const input = form.querySelector('input[name="q"]');
      if (!input) return;

      form.addEventListener('submit', function () {
        const term = stripTrailingWildcard(input.value.trim());
        if (term) input.value = term + '*';
      });
    });

    // 2) Na página de resultados: limpa o "*" que o Shopify devolve em
    //    search.terms — tanto nos inputs quanto no título.
    document.querySelectorAll('input[name="q"]').forEach(function (input) {
      const cleaned = stripTrailingWildcard(input.value);
      if (cleaned !== input.value) input.value = cleaned;
    });

    const title = document.querySelector('h1.page-header');
    if (title) {
      // O termo aparece entre aspas: ...PARA "BLUSA ROSA*". Remove o "*"
      // imediatamente antes da aspa de fechamento (reta ou tipográfica) ou no fim.
      const cleaned = title.textContent.replace(/\*(?=\s*(["'”’»“]|$))/, '');
      if (cleaned !== title.textContent) title.textContent = cleaned;
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
